import React, { useState } from 'react';
import { TabContext } from '@mui/lab';
import { StyledTab, StyledTabList, StyledTabPanel } from 'shared/styles/StyledTabs';
import { useGetUserQuery } from 'features/getUsers/api/getUsersApi';
import { useParams } from 'react-router-dom';
import { UpdatePersonalDataCard } from 'entities/users/ui/UpdatePersonalDataCard';
import { CircularLoader } from 'shared/ui/CircularLoader/CircularLoader';
import { UpdateUserDataCard } from 'entities/users/ui/UpdateUserDataCard';

export const UpdateUserCardTabs = () => {
  const { id } = useParams();

  const [tab, setTab] = useState('0');

  const { data: user, isSuccess: isProfileSuccess } = useGetUserQuery(id!);

  const handleChangeTab = (_: React.SyntheticEvent, newTab: string) => setTab(newTab);

  if (!isProfileSuccess) {
    return <CircularLoader />;
  }

  return (
    <TabContext value={tab}>
      <StyledTabList onChange={handleChangeTab}>
        <StyledTab
          label="Анкетные данные"
          value="0"
          disableRipple
        />
        <StyledTab
          label="Пользовательские данные"
          value="1"
          disableRipple
        />
      </StyledTabList>
      <StyledTabPanel value="0">
        <UpdatePersonalDataCard user={user} />
      </StyledTabPanel>
      <StyledTabPanel value="1">
        <UpdateUserDataCard user={user} />
      </StyledTabPanel>
    </TabContext>
  );
};
